<template>
  <div class="BaseArticlePage">
    <BaseCommonPage>
      <div class="container-fluid fun_container area_funcontents">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <FuncSearchGallery />

              <h1 class="thema_func">
                <span class="glyphicon glyphicon-tag"></span>
                スマホでカラリオ年賀を最新版にアップデートしてください
              </h1>


              <AppDownloadColorioNenga/>

            </div>
          </div>

        </div>
      </div>

      <div class="container fun_top">
        <p class="text-center">
          <FuncSearchGalleryTop>
            <LabelFunMessage fcontId="0" msgkey="14" />&nbsp;&raquo;
          </FuncSearchGalleryTop>
        </p>
      </div>
      
      <InstaGalleryButton />
      
    </BaseCommonPage>
  </div>
</template>

<script>
import BaseCommonPage from "./BaseCommonPage";
import FuncSearchGallery from "../components/FuncSearchGallery";
import LabelFunMessage from "../components/LabelFunMessage";
import InstaGalleryButton from "../components/InstaGalleryButton";
import FuncSearchGalleryTop from "../components/FuncSearchGalleryTop";
import AppDownloadColorioNenga from "../components/AppDownloadColorioNenga";

export default {
  name: "PremiumNengaPage",
  components: {
    BaseCommonPage,
    LabelFunMessage,
    FuncSearchGallery,
    InstaGalleryButton,
    FuncSearchGalleryTop,
    AppDownloadColorioNenga
  },
  computed: {

  },
  metaInfo() {
    return {
      title: "スマホでカラリオ年賀を最新版にアップデートしてください",
      meta: [
        {
          name: "description",
          content:
            "スマホでカラリオ年賀を最新版にアップデートしてください",
        },
      ],
    };
  },
};
</script>

<style scoped>
.thema_func {
  line-height: 1.4;
}

</style>
